import {Component} from '@angular/core';

@Component({
  selector: 'app-demo',
  template: '',
  standalone: true,
})
export class DemoComponent {}
